import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_PROJECT_INSPECTION_HISTORY',
  GET: 'GET_PROJECT_HISTORY',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT_INSPECTION_HISTORY'
}

export const listProjectInspectionHistory = (pageSize, page, filtered, date, developer) => {
  return {
    type: ACTION.LIST,
    payload: searchProjectInspectionHistory(pageSize, page, filtered, date, developer)
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const searchProjectInspectionHistory = (pageSize, page, filtered, date, developer) => {
  var parameters = new URLSearchParams();
  if (filtered) {
    parameters.append("search", filtered);
  }
  if (date) {
    parameters.append("date", date);
  }
  if (developer) {
    parameters.append("developer", developer);
  }
  parameters.append("limit", pageSize);
  parameters.append("offset", pageSize * page);
  parameters.append("status", "Approved");
  parameters.append("status", "Rejected");

  return RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_INSPECTION,
    params: parameters,
  });
};

export const clearErrorProjectInspection = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};


// WEBPACK FOOTER //
// ./src/redux/project_inspection/project_inspection_history_actions.js